import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './locals/i18n';
import { document, window } from "global";

const botframe=document.getElementById('botframe');

// ReactDOM.render(<App />, document.getElementById('botframe'));
if (typeof window !== 'undefined') {
    if(botframe)
    ReactDOM.render(<App />, botframe);
}
